const modules = (context, store) => {
  context.keys().forEach(k => {
    store.registerModule(k.slice(2, -3), context(k).default);
  });
};

const Store = exports = module.exports = { // eslint-disable-line
  store: null,
  sync(store) {
    Store.store = store;
    const originalContext = require.context('./modules/', false, /\.js$/);
    modules(originalContext, store);
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/index.js